import React from 'react';
import { useNavigate } from 'react-router-dom';
import LazyImage from './LazyImage';

const CategoryCard = React.memo(({ category }) => {
  const navigate = useNavigate();

  return (
    <div
      onClick={() => navigate(`/category/${category.id}`)}
      className="flex flex-col items-center justify-center gap-3 p-4 bg-white border border-[#1A3626]/10 rounded-lg hover:border-[#1A3626]/30 hover:-translate-y-1 hover:shadow-md transition-all cursor-pointer text-center"
      data-testid={`category-card-${category.id}`}
    >
      <div className="w-full aspect-square rounded-md overflow-hidden bg-gray-100 relative">
        <LazyImage
          src={category.image_url}
          alt={category.name}
          className="w-full h-full relative overflow-hidden"
        />
      </div>
      <h3 className="text-sm sm:text-base font-semibold text-[#1A3626] line-clamp-2">
        {category.name}
      </h3>
    </div>
  );
});

CategoryCard.displayName = 'CategoryCard';

export default CategoryCard;
